import axios from "axios";
import {baseUrlIdeal} from "../../config/api/apiConfig";

const newBaseUrl = baseUrlIdeal?.replace("ideal-backend", "");

class SendIdealMessageService {
    private axios = axios.create({
        baseURL: newBaseUrl,
    });

    public async sendMessage(params?: any) {
        try {
            return await this.axios.post<any>('/post-message/send/template',
                params, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
        } catch (e: any) {
            throw new Error(" Server Send WhatsApp: " + e?.response?.data?.messages);
            // throw new Error("Error Server Send WhatsApp: "+e?.response?.data?.data?.error?.message+" Trace Error: "+e?.response?.data?.data?.error?.fbtrace_id);
        }
    }
}

export const sendIdealMessageService = new SendIdealMessageService();
